module.exports = __webpack_public_path__ + "static/nasa-cover-cropped-compressed-0ca315d76036fd16a5d89db97365560b.jpeg";